module.exports = __webpack_public_path__ + "static/media/icons.f4ab23f0.svg";